import ListAdvice from "app/views/inward/advice/list-advice";
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
// import ListReceiving from "app/views/wms-inward/receiving/list-Receiving";
// // import CreateAdvice from "./advice/create-advice";

// import { AddEditReceiving } from "./receiving/AddEdit";
// import { PutawayAssignment } from "./receiving/putaway-assignment";
const CreateAdvice = Loadable(lazy(() => import('./advice/create-advice')));
const WmsInwardRoutes = [
    {
        path: '/inward/advice/list',
        element: <ListAdvice />
    },
    {
        path: '/inward/advice/create',
        element: <CreateAdvice />
    },
    // {
    //     path: '/inward/Receiving/list',
    //     element: <ListReceiving />
    // },
    // {
    //     path: '/inward/Receiving/create',
    //     element: <AddEditReceiving />
    // }
    // ,
    // {
    //     path: '/inward/Putaway/assign',
    //     element: <PutawayAssignment />
    // }

];
export default WmsInwardRoutes;